import { Component, inject, input, OnDestroy, output, signal } from '@angular/core';
import { faClose, faUpRightAndDownLeftFromCenter } from '@fortawesome/pro-solid-svg-icons';

import { MediaService } from '@eiq/files';
import { Media } from '@eiq/files/models';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'empathy-option-media',
  templateUrl: 'option-media.component.html',
  styleUrls: ['./option-media.component.scss']
})
export class OptionMediaComponent implements OnDestroy {
  altText = input<string>(null);
  // media = input<Media>();
  media = input(null, {
    transform: (value: Media | null) => {
      if (!value) {
        return null;
      }
      return this.mapStimulusView(value);
    }
  });
  align = input<'start' | 'center'>('start');
  noBorder = input<boolean>(false);

  clicked = output<void>();

  expanded$ = signal<boolean>(false);

  faClose = faClose;
  faUpRightAndDownLeftFromCenter = faUpRightAndDownLeftFromCenter;

  private mediaService = inject(MediaService);

  private destroyed$: Subject<boolean> = new Subject();

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  private mapStimulusView(stimulus: Media): Media {
    // TODO: EQ-1099 SurveyEditorService should keep the state of the stimulus so them are not fecth again and again.

    if (!stimulus.url) {
      this.mediaService
        .getMediaUrl(stimulus.mediaId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((media) => (stimulus.url = media.url));
    }

    return stimulus;
  }
}
